import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import swal from "sweetalert";

import CPF from "gerador-validador-cpf";

import api from "services/api";

import { Icon, Loading } from "components";

class Document extends Component {
  state = {
    open: false,
    loading: false,
  };

  handleToggle = () => {
    const { open } = this.state;

    this.setState({ open: !open });
  };

  getDocumentSituation = (situation) => {
    switch (situation) {
      case "approved":
        return "aprovado";
      case "rejected":
        return "reprovado";
      case "cancelled":
        return "cancelado";
      default:
        return "pendente";
    }
  };

  handleGenerateAndApprove = async (inhabitantId) => {
    const { onUpdate } = this.props;

    try {
      this.setState({ loading: true });
      await api.post("/user/v2/generate_and_approval_docs", {
        user_inhabitant: {
          id: inhabitantId,
        },
      });

      onUpdate()
      swal("Sucesso", "Documento gerado e aprovado com sucesso.", "success");
    } catch (err) {
      swal(
        "Falha ao gerar documento",
        "Não foi possível gerar o documento do profissional, entre em contato com o administrador.",
        "error"
      );
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { document, filters } = this.props;
    const { open, loading } = this.state;

    return (
      <Fragment>
        <tr>
          <td>{document.attributes.inhabitant.name} </td>
          <td>{CPF.format(document.attributes.inhabitant.cpf)}</td>
          <td>
            {document.attributes.document !== null
              ? document.attributes.document.number
              : "sem documento"}
          </td>
          <td>
            {document.attributes.situation !== null
              ? this.getDocumentSituation(
                  document.attributes.document.situation
                )
              : ""}
          </td>
          <td className="row text-right" width="280">
            {document.attributes.document !== null ? (
              <Fragment>
                <Link
                  to={{
                    pathname: `/professionals/documents/${document.attributes.document.document_request_id}/edit`,
                    filters,
                  }}
                  className="button-icon"
                >
                  <span className="glyph glyph-eye" />
                </Link>

                <button className="button-icon" onClick={this.handleToggle}>
                  <Icon name="plus" prefix="fa" />
                </button>
              </Fragment>
            ) : (
              <Fragment>
                {document.attributes.inhabitant !== null && (
                  <button
                    className="button-icon-with-text"
                    onClick={() =>
                      this.handleGenerateAndApprove(
                        document.attributes.inhabitant.id
                      )
                    }
                    disabled={loading}
                  >
                    {loading ? (
                      <Loading
                        type="btn"
                        size="small"
                        text="Gerando..."
                        style={{ marginTop: 0 }}
                      />
                    ) : (
                      <Fragment>
                        <Icon name="check" prefix="fa" />
                        Gerar e Aprovar EAD
                      </Fragment>
                    )}
                  </button>
                )}
              </Fragment>
            )}
          </td>
        </tr>
        {open && (
          <tr>
            <td colSpan="7" style={{ maxWidth: 300 }}>
              <Fragment>
                <p>
                  <b>Nome Completo: </b>
                  {document.attributes.document.documentable.name}
                </p>
                <p>
                  <b>Loja: </b>
                  {document.attributes.document.documentable.store_place.name}
                </p>
                {document.attributes.situation === "rejected" ||
                document.attributes.situation === "approved" ? (
                  <p>{`Responsável pela aprovação/reprovação do documento ${document.attributes.inhabitant.name}`}</p>
                ) : (
                  ""
                )}
              </Fragment>
            </td>
          </tr>
        )}
      </Fragment>
    );
  }
}

export default Document;
